import PageHeader from "../components/PageHeader";
import SEOMeta from "../components/SEOMeta";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <SEOMeta
        title="Terms of Use"
        description="Terms of Use for the Dugavu Ventures website. Dugavu Ventures is a global consulting firm specialising in corporate strategy, mining, minerals, and oil and gas advisory."
        url="/terms"
      />
      <PageHeader
        eyebrow="Legal"
        title="Terms of Use."
        lede="The terms on which this website is provided. Engagements are governed by separate written agreements."
        testid="terms-header"
      />
      <section className="py-20 md:py-28">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-3">
              <div className="eyebrow">Last updated</div>
              <p className="mt-2 text-[14px] text-slate font-mono">December 2025</p>
            </div>
            <div className="md:col-span-9 max-w-3xl space-y-6 text-charcoal text-[16px] leading-relaxed">
              <h2 className="font-serif text-2xl text-ink">Use of this website</h2>
              <p>This website is provided for general information about Dugavu Ventures Ltd and the services we offer. Nothing on this site constitutes advice or a binding offer of services.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Engagement agreements</h2>
              <p>Advisory engagements are governed by written engagement letters. The terms of those letters take precedence over anything on this website.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Intellectual property</h2>
              <p>All content on this website — including text, images, marks, and arrangement — is the property of Dugavu Ventures Ltd or used under licence. It may not be reproduced without permission.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">External links</h2>
              <p>Where this site links to third-party content, we do not warrant the accuracy or availability of that content.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Governing law</h2>
              <p>These terms are governed by the laws of Uganda.</p>

              <h2 className="font-serif text-2xl text-ink mt-8">Contact</h2>
              <p>Queries about these terms should be addressed to <a href="mailto:info@dugavuventures.com" className="text-oxblood link-rule">info@dugavuventures.com</a>.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
